module.exports = __webpack_public_path__ + "img/21.cafec960.jpg";